var symphony = symphony || {};

;
(function () {

  symphony.donateHeaderActions = function () {

    $('.js-donateHeader').on('click', function (e) {
      e.preventDefault();
      performDonateHeaderToggle(this);
    });
    $('.js-donateHeader').on('keypress', function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        performDonateHeaderToggle(this);
      }
    });

    function performDonateHeaderToggle(elm) {
      // On certain pages, check to make sure that .expandingHeader has been initialized correctly.
      if (!disableDonationDropDown && (symphony.config.utilities.expandingHeader == null || symphony.config.utilities.expandingHeader.length == 0)) {
        symphony.config.utilities.expandingHeader = $(".js-doesExpand");
      }

      if (!$('body').hasClass('kroc-theme') && !$('body').hasClass('header-isSticky')) {
        $('body').addClass('header-isSticky');
      }

      if (!disableDonationDropDown && symphony.config.utilities.expandingHeader.hasClass('isExpanded')) {
        $(elm).removeClass('donateHeader-expanded');
        symphony.config.utilities.expandingHeader.removeClass('isExpanded');
      } else {
        if (disableDonationDropDown) {
          var donateUrl = $('a.js-donateHeader').attr('href');
          window.open(donateUrl);  
        } else {
          $(elm).addClass('donateHeader-expanded');
          $('.donateHeader').addClass('isExpanded');
        }
      }
    }

    $('.donateHeader-amounts').find('a').on('click', function (e) {
      e.preventDefault();
      $('.donateHeader-amounts').find('a').removeClass('isSelected');
      $(this).addClass('isSelected');
    });

    $('.donateHeader-submit').find('a').on('click', function (e) {
      e.preventDefault();
      performDonateSubmit();
    });
    $('.donateHeader-submit').find('a').on('keypress', function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        performDonateSubmit();
      }
    });

    function performDonateSubmit() {
      var donateUrl = $('.donateHeader-amounts').find('a.isSelected').attr('href');
      if (_.isUndefined(donateUrl)) {
        donateUrl = $('.donateHeader-amounts a:last-child').attr('href');
      }
      if (_.isUndefined(donateUrl) || disableDonationPassthru) {
        donateUrl = $('a.js-donateHeader').attr('href');
      }
      if (typeof utag != 'undefined') {
        var amt = UTIL.GetQueryStringParameterByName('amount', donateUrl);
        if (typeof amt == "undefined" || amt == undefined || amt == null || amt == "" || amt == "Other") {
          amt = UTIL.GetQueryStringParameterByName('amt', donateUrl);
        }
        if (typeof amt == "undefined" || amt == undefined || amt == null || amt == "" || amt == "Other") {
          amt = '';
        }
    
       window.open(donateUrl);
          
      } else {
        window.open(donateUrl);
      }
    }

  };

})();
